import React from "react";
import { Container } from "react-bootstrap";
import uiux from "../../../../Asset/wo-hero-ux.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-2">
              <div className="info-content">
                <p>
                  The various stages are Research, Wireframes, User Testing,
                  Look and Feel Design, Front-End Code Development, and
                  Integration Support. This guarantees that our esteemed clients
                  get arrangements that are both valuable to their particular
                  necessities and are reasonable, as well.
                </p>
                <ul className="check-list count_2 pt-4">
                  <li>UI DESIGN</li>
                  <li>UI DEVELOPMENT</li>
                  <li>UI GUIDELINES</li>
                  <li>DESIGN SYSTEM</li>
                  <li>UX DESIGN</li>
                  <li>USER RESEARCH</li>
                  <li>UX CONSULTANCY</li>
                  <li>UX WRITING</li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-1">
              <div className="info-img">
                <img alt="infoImage" src={uiux} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
